export const STORAGE_KEY_HIDE_ONBOARDING = 'STORAGE_KEY_HIDE_ONBOARDING'
export const STORAGE_KEY_TRAFFIC_CHECKLIST = 'STORAGE_KEY_TRAFFIC_CHECKLIST'
export const STORAGE_KEY_ENERGY_SCREW_OVERVIEW_LIST = 'STORAGE_KEY_ENERGY_SCREW_OVERVIEW_LIST'
export const STORAGE_KEY_TRAFFIC_PATH_OVERVIEW_LIST = 'STORAGE_KEY_TRAFFIC_PATH_OVERVIEW_LIST'
export const STORAGE_KEY_ENERGY_CONDITIONS_OVERVIEW_LIST = 'STORAGE_KEY_ENERGY_CONDITIONS_OVERVIEW_LIST'
